import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function StarFill({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M12.7943 2.56631C12.6415 2.26193 12.3301 2.06983 11.9895 2.06995C11.649 2.07007 11.3377 2.26239 11.1852 2.56688L8.58039 7.76721L2.87717 8.48703C2.53825 8.52981 2.25276 8.76078 2.14016 9.0833C2.02756 9.40582 2.10727 9.76428 2.34592 10.0087L6.40475 14.1656L5.29568 19.8218C5.23031 20.1552 5.35825 20.497 5.62647 20.7055C5.89469 20.914 6.25747 20.9537 6.56445 20.8082L12.0016 18.2302L17.4161 20.7745C17.7231 20.9187 18.0851 20.8782 18.3525 20.6695C18.6199 20.4609 18.7473 20.1196 18.682 19.7868L17.5732 14.1316L21.6317 9.98985C21.8712 9.74547 21.9513 9.38643 21.8386 9.06339C21.7259 8.74034 21.4397 8.50916 21.1002 8.46685L15.3985 7.75634L12.7943 2.56631Z" fill="currentColor" /></Svg>;
}
export default StarFill;